import { createFileRoute } from "@tanstack/react-router";
import { FreeTestPage } from "@/components/free-test/FreeTestPage";
import { freeTestHead } from "@/components/free-test/free-test-head";

// Бесплатный мини-тест (en) — тот же тест из 4 вопросов, что на главной.
export const Route = createFileRoute("/en/free-career-test")({
  head: () => freeTestHead("en"),
  component: () => <FreeTestPage lang="en" />,
});
